import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "backup-outter-container flex-center" };
var _hoisted_2 = ["innerHTML"];
import { ref, watch, computed } from "vue";
import { html } from "diff2html";
import { ColorSchemeType } from "diff2html/lib/types";
import { createTwoFilesPatch } from "diff";
import { useRoute } from "vue-router";
import { useStore } from "@/store";
import { MdPreview, config } from "md-editor-v3";
import "md-editor-v3/lib/style.css"; // MD 引入样式，否则主题无效!!!!!!!>
import { processMdContent } from "@/utils/phrase";
import "diff2html/bundles/css/diff2html.min.css";
import api from "@/utils/api";
// 计划面板：diff2html，原文预览，原文 raw
export default /*@__PURE__*/ _defineComponent({
    __name: 'postReleaseDetail',
    setup: function (__props) {
        var oldText = ref("");
        var newText = ref("");
        var diffHtml = ref("");
        var route = useRoute();
        var store = useStore();
        var postid = route.params.postid;
        var uuid = route.params.uuid;
        var selectedPanel = ref("差异对比");
        var computedOldText = computed(function () {
            return processMdContent(oldText.value);
        });
        window.resourceBaseUrl = "https://".concat(window.location.host, "/backup/").concat(postid, "/").concat(uuid);
        store.setPageName("\u5907\u4EFD\u67E5\u770B-\u6587\u7AE0 ".concat(postid, "- ").concat(uuid, " \u7684\u5907\u4EFD\u5BF9\u6BD4"));
        var isNewTextLoaded = false, isOldTextLoaded = false;
        var checkIsLoaded = function () {
            if (isNewTextLoaded && isOldTextLoaded) {
                generateDiff();
            }
        };
        api.requestBaseWithMask
            .get("https://".concat(window.location.host, "/md/").concat(postid, "/markdown.md?t=").concat(Date.now()))
            .then(function (res) {
            newText.value = res.data;
            isNewTextLoaded = true;
            checkIsLoaded();
        })
            .catch(function (err) {
            window.$notifyError("获取原文失败", err.response.msg);
        });
        api.requestBaseWithMask
            .get("/backup/".concat(postid, "/").concat(uuid, "/markdown.md"))
            .then(function (res) {
            oldText.value = res.data;
            isOldTextLoaded = true;
            checkIsLoaded();
        })
            .catch(function (err) {
            window.$notifyError("获取备份失败", err.response.msg);
        });
        var generateDiff = function () {
            var diff = createTwoFilesPatch("Old Text", "New Text", oldText.value, newText.value);
            diffHtml.value = html(diff, {
                outputFormat: "side-by-side",
                drawFileList: false,
                matching: "words",
                // colorScheme: "dark", // light or dark
                // ts 写法
                colorScheme: store.isDarkTheme
                    ? ColorSchemeType.DARK
                    : ColorSchemeType.LIGHT,
            });
        };
        watch(function () { return store.isDarkTheme; }, function () {
            generateDiff();
        });
        config({
            markdownItPlugins: function (plugins) {
                return plugins.filter(function (p) { return p.type !== "xss"; });
            },
        });
        var mdHeadingId = function (text, _level, index) {
            return "heading-".concat(text, "-").concat(index);
        };
        // onMounted(() => {
        //   generateDiff();
        // });
        return function (_ctx, _cache) {
            var _component_n_tab_pane = _resolveComponent("n-tab-pane");
            var _component_n_tabs = _resolveComponent("n-tabs");
            var _component_n_card = _resolveComponent("n-card");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_n_card, { class: "backup-container" }, {
                    default: _withCtx(function () { return [
                        _createVNode(_component_n_tabs, {
                            value: selectedPanel.value,
                            "onUpdate:value": _cache[0] || (_cache[0] = function ($event) { return ((selectedPanel).value = $event); }),
                            animated: "",
                            class: "backup-panels"
                        }, {
                            default: _withCtx(function () { return [
                                _createVNode(_component_n_tab_pane, {
                                    key: "diff",
                                    tab: "差异对比",
                                    name: "差异对比"
                                }, {
                                    default: _withCtx(function () { return [
                                        _createElementVNode("div", {
                                            class: "diff-html-show",
                                            innerHTML: diffHtml.value
                                        }, null, 8, _hoisted_2)
                                    ]; }),
                                    _: 1
                                }),
                                _createVNode(_component_n_tab_pane, {
                                    key: "raw",
                                    tab: "原文",
                                    name: "原文"
                                }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(_unref(MdPreview), {
                                            theme: _unref(store).isDarkTheme ? 'dark' : 'light',
                                            id: "postContent",
                                            editorId: _unref(postid),
                                            modelValue: computedOldText.value,
                                            autoFoldThreshold: 80,
                                            mdHeadingId: mdHeadingId
                                        }, null, 8, ["theme", "editorId", "modelValue"])
                                    ]; }),
                                    _: 1
                                })
                            ]; }),
                            _: 1
                        }, 8, ["value"])
                    ]; }),
                    _: 1
                })
            ]));
        };
    }
});
